import { useCallback } from 'react';
import { useFocusEffect } from '@react-navigation/native';

import {
  type BrazePushNotificationPayload,
  useOnBrazePushNotificationReceived,
} from '../../../../context/Braze';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * A hook that sets up a listener for when a in-store completed order push
 * notification is received.
 */
export const useScanToPayNotifications = (params: Params) => {
  const { onOrderCompleted } = params;

  // ─── Helpers ─────────────────────────────────────────────────────────────────

  const onPushNotificationReceived = useCallback(
    (payload?: BrazePushNotificationPayload) => {
      const extras = payload?.extras;
      const isValidNotification = extras?.order_status === 'in_store.completed';

      // Ignore other notifications
      if (!isValidNotification) return;

      onOrderCompleted();
    },
    [onOrderCompleted],
  );

  // ─────────────────────────────────────────────────────────────────────────────

  const onNotificationReceived = useOnBrazePushNotificationReceived({
    onPushNotificationReceived,
  });

  // ─── Effects ─────────────────────────────────────────────────────────────────

  useFocusEffect(onNotificationReceived);
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  onOrderCompleted: () => void;
};
